import cx from 'classnames';
import styles from '../../styles/common/table.scss';

interface Props {
  children: any[];
  tableClassname: string;
}

const SearchResultTable = ({ children, tableClassname }: Props) => (
  <div className={cx(styles.table, tableClassname)}>{children}</div>
);

export default SearchResultTable;



// WEBPACK FOOTER //
// ./components/search/searchResultTable.tsx